import HealthBadge from './HealthBadge'

export default HealthBadge
